<mat-card appearance="outlined" class="dialog-card">
  <button class="close-btn" mat-icon-button (click)="onClose()" [attr.aria-label]="'common.close'|traduccion">
    <mat-icon>close</mat-icon>
  </button>

  <h2>{{'commissions.help.title'|traduccion}}</h2>
  <p [innerHTML]="'commissions.help.intro'|traduccion"></p>
  <p>{{'commissions.help.conditionsIntro'|traduccion}}</p>

  <ul>
    <li [innerHTML]="'commissions.help.condition1'|traduccion"></li>
    <li [innerHTML]="'commissions.help.condition2'|traduccion"></li>
    <li [innerHTML]="'commissions.help.condition3'|traduccion"></li>
    <li [innerHTML]="'commissions.help.condition4'|traduccion"></li>
  </ul>

  <p>
    {{'commissions.help.contactBefore'|traduccion}}
    <a href="mailto:contacta@mylocker.site">contacta&#64;mylocker.site</a>
  </p>

  <h3>{{'commissions.help.noInvoiceTitle'|traduccion}}</h3>
  <p>{{'commissions.help.noInvoiceText'|traduccion}}</p>
  <p [innerHTML]="'commissions.help.useCredit'|traduccion"></p>
</mat-card>
